import { useMutation, useQueryClient } from '@tanstack/react-query';

import { teamMembershipDelete } from '@api/sdk.gen';

import { promiseSequence } from '@/portainer/helpers/promise-utils';
import { userQueryKeys } from '@/portainer/users/queries/queryKeys';
import { UserId } from '@/portainer/users/types';
import { withError, withInvalidate } from '@/react-tools/react-query';
import { teamQueryKeys } from '@/react/portainer/users/teams/queries/query-keys';
import { TeamMembershipId } from '@/react/portainer/users/teams/types';

export function useRemoveUserMembershipsMutation(userId: UserId) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (membershipIds: Array<TeamMembershipId>) =>
      promiseSequence(
        membershipIds.map(
          (membershipId) => () => removeMembership(membershipId)
        )
      ),
    ...withError('Unable to remove the user from the team(s)'),
    ...withInvalidate(queryClient, [
      teamQueryKeys.base(),
      userQueryKeys.memberships(userId),
    ]),
  });
}

async function removeMembership(membershipId: TeamMembershipId) {
  await teamMembershipDelete({ path: { id: membershipId } });
}
